export default __webpack_public_path__ + "static/media/project_thumbnail_soulsearch.478ae59c.png";